import { Folder } from '@dc-shared-web/hooks'
import { AxiosInstance } from 'axios'

export type MoveFolderParams = {
  name: string
  office_uuid: string
  parent_uuid: string
  type: 'folder' | 'project' | 'dashboard' | 'document'
  uuid: string
}

export const moveFolder = async (
  apiClient: AxiosInstance,
  params: MoveFolderParams
): Promise<Folder> => {
  const type = params.type === 'dashboard' ? null : params.type
  const parent_uuid =
    params.parent_uuid === 'dashboard' ? null : params.parent_uuid
  const { data } = await apiClient.patch(`/api/folders/${params.uuid}`, {
    name: params.name,
    parent_uuid,
    parent_type: type,
    office_uuid: params.office_uuid,
  })

  return data
}
